/**
 * Country-code constants — single source of truth for the ISO 3166-1 alpha-2
 * codes the app special-cases.
 *
 * Poland is currently the only country with bespoke basemaps and standard
 * layers (Geoportal orthophoto, road/border overlays). Centralizing the literal
 * here lets feature scopes (see `src/config/mapFeatures.ts`) and the workspace
 * default reference one constant instead of scattering `'PL'` across modules.
 */

/** ISO 3166-1 alpha-2 code for Poland. */
export const POLAND_COUNTRY_CODE = 'PL';

/**
 * Country code assumed for a workspace that has no saved map settings yet.
 * Defaults to Poland so the existing PL-centric experience is preserved until
 * configuration loads.
 */
export const DEFAULT_WORKSPACE_COUNTRY_CODE = POLAND_COUNTRY_CODE;
